import PageWidthContainer from "../../../shared/components/PageWidthContainer/PageWidthContainer";
import {
  ComponentHalfSpacing,
  ComponentSpacing,
} from "../../../shared/components/Spacing/Spacing";
import styles from "./styles.module.css";

export default function Footer({ contrastText }: { contrastText?: boolean }) {
  const encodedSACMessage = encodeURIComponent(
    "Oi! Tenho uma dúvida, sugestão, elogio ou reclamação referente a figurinhas.web.app."
  );

  const myNumber = "5561999454459";

  return (
    <footer
      className={contrastText ? styles["contrast-footer"] : styles.footer}
    >
      <PageWidthContainer>
        <div className={styles.container}>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.linkedin.com/in/tour%C3%A9-holder-63576a10b/"
          >
            <div className={styles.line}>
              {" "}
              <span>© 2022</span>
              <ComponentHalfSpacing />
              <strong>·</strong>
              <ComponentHalfSpacing />
              <strong> Touré Holder</strong>
            </div>
          </a>

          <div className={contrastText ? styles["contrast-link"] : styles.link}>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={`https://wa.me/${myNumber}?text=${encodedSACMessage}`}
            >
              Dúvidas, sugestões, elogios, reclamações? Fale com o dev :)
            </a>
          </div>
          <ComponentSpacing />
        </div>
      </PageWidthContainer>
    </footer>
  );
}
